/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.reminders.di

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module
import studio.oddpods.cauce.core.intent.WhatsAppLauncher
import studio.oddpods.cauce.feature.reminders.RemindersViewModel

val RemindersModule = module {
    viewModel {
        RemindersViewModel(
            reminderRepository = get(),
            profileRepository = get(),
            launchWhatsApp = { phone, msg -> get<WhatsAppLauncher>().launch(phone, msg) },
            renderTemplate = get(),
            paymentRepository = get(),
            dateFormatter = get(),
        )
    }
}
